import { render, staticRenderFns } from "./HistoricalDataTables.vue?vue&type=template&id=08d389e3"
import script from "./HistoricalDataTables.vue?vue&type=script&lang=js"
export * from "./HistoricalDataTables.vue?vue&type=script&lang=js"
import style0 from "./HistoricalDataTables.vue?vue&type=style&index=0&id=08d389e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports